import React from 'react'
import { useIntl } from 'react-intl'
import { openURIInApp } from '../../utils/URLSchemeHelper'

const ContactDetail = () => {
  const intl = useIntl()

  const renderFooterMessage = () => {
    switch (intl.locale) {
      case 'en':
        return (
          <p className="d-Contact-text">
            {intl.formatMessage({id: "ContactDetail.footer1"})}{intl.formatMessage({id: "ContactDetail.footer2"})}<a onClick={() => openURIInApp('https://www.sotetsu.co.jp/contact_form/input', 'INQUIRIES', 'SOTETSU_CONTACT')}>{intl.formatMessage({id: "ContactDetail.footerHere"})}</a>
          </p>
        )
      default:
        return (
          <p className="d-Contact-text">
            {intl.formatMessage({id: "ContactDetail.footer1"})}<a onClick={() => openURIInApp('https://www.sotetsu.co.jp/contact_form/input', 'INQUIRIES', 'SOTETSU_CONTACT')}>{intl.formatMessage({id: "ContactDetail.footerHere"})}</a>{intl.formatMessage({id: "ContactDetail.footer2"})}
          </p>
        )
    }
  }

  return (
    <div className="d-Contact">
      <p className="d-Contact-text">
        {intl.formatMessage({id: "ContactDetail.title"})}
      </p>
      <p className="d-Contact-text">
        {intl.formatMessage({id: "ContactDetail.body1"})}<br />
        {intl.formatMessage({id: "ContactDetail.body2"})}<br />
        {intl.formatMessage({id: "ContactDetail.body3"})}
      </p>
      {renderFooterMessage()}
    </div>
  )
}

export default ContactDetail
